import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { AgentResponseBubbleNodeComponent } from "./Component"

export const AgentResponseBubbleNode = Node.create({
	name: "AgentResponseBubbleNode",
	group: "block",
	content: "block+",
	selectable: false,
	atom: true,
	addAttributes() {
		return {
			response_id: {
				isRequired: true,
			},
			rating: {
				isRequired: false,
			},
			created_at: {
				isRequired: true,
			},
		}
	},
	parseHTML() {
		return [{ tag: "agent-response" }]
	},
	renderHTML({ HTMLAttributes }) {
		return ["agent-response", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(AgentResponseBubbleNodeComponent)
	},
})
